import React, { useEffect } from 'react';
import SideMenu from '../SideMenu';
import PropTypes from 'prop-types';
import useApi from '../../api/useApi';
import { useStateValue } from '../../ContextApi/StateProvider';

const Layout = ({ children }) => {
  const [{ user }, dispatch] = useStateValue();
  const [{ isLoading, isError, data }, getUserDetails] = useApi();

  useEffect(() => {
    if (user) {
      getUserDetails(`/user/${user.userId}`, 'GET');
    }
  }, []);

  useEffect(() => {
    if (!isLoading && !isError && data) {
      let x = {
        ...JSON.parse(localStorage.user),
        ...data,
      };
      dispatch({
        type: 'USER_DATA',
        user: data.user,
      });
      localStorage.user = JSON.stringify(x);
    }
  }, [isLoading, isError, data]);

  return (
    <div className="min-h-screen" style={{ background: 'rgb(244, 246, 248)' }}>
      <div className="flex">
        {user && <SideMenu />}
        {children}
      </div>
    </div>
  );
};

Layout.propTypes = {
  children: PropTypes.any.isRequired,
};

export default Layout;
